import { render } from "./ProviderTuto.vue?vue&type=template&id=775cfe2b&scoped=true"
import script from "./ProviderTuto.vue?vue&type=script&lang=js"
export * from "./ProviderTuto.vue?vue&type=script&lang=js"

import "./ProviderTuto.vue?vue&type=style&index=0&id=775cfe2b&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-775cfe2b"]])

export default __exports__